/**
 * 계약 정보 컴포넌트
 * 계약서의 기본 정보를 표시하고 관리하는 컴포넌트입니다.
 * 계약명, 계약기간, 계약금액 등의 정보를 표시하고 편집할 수 있습니다.
 */

import { useState } from "react";
import { DetailTotalData } from "src/api/contract/contract-types";
import { ArticleSection } from "src/components/layout/ArticleSection";
import ContractInfoDetail from "./detailComponent/ContractInfoDetail";
import ContractInfoEdit from "./editComponent/ContractInfoEdit";

/**
 * 계약 정보 컴포넌트의 props 인터페이스
 */
interface ContractBasicProp {
  detailData: DetailTotalData; // 상품 상세 조회 정보
  setData: Function; // 데이터 업데이트 함수
}

/**
 * 계약 정보 컴포넌트
 * @param detailData 계약 상세 정보
 * @param setData 데이터 업데이트 함수
 */
const ContractInfo = ({ detailData, setData }: ContractBasicProp) => {
  const [editable, setEditable] = useState(false); // 편집 모드 상태
  const [saveFlags, setSaveFlags] = useState(false); // 저장 상태 플래그
  const [popupState, setPopupState] = useState(false); // 팝업 상태
  const [editConfrim, setEditConfrim] = useState(false); // 편집 확인 상태
  const [commonModals, setCommonModals] = useState<any>({
    // 공통 모달 상태
    message: "",
    title: "",
  });

  const [contractSignType, setContractSignType] = useState({ directContract: true, isEsign: false, isModuSign: false }); // 전자서명 상태

  return (
    <ArticleSection
      title={"계약 정보"}
      isEditable={editable}
      setIsEditable={setEditable}
      onClickSave={() => setSaveFlags(true)}
      popupState={popupState}
      setPopupState={setPopupState}
      editConfrim={editConfrim}
      setEditConfrim={setEditConfrim}
      commonModals={commonModals}
      // disabledState={[String(detailData?.contract?.contractStep), String(detailData?.product.productType)]}
      children={
        editable === false ? (
          <ContractInfoDetail
            detailData={detailData}
            setData={setData}
            editable={editable}
            contractSignType={contractSignType}
            onChangeContractSignType={setContractSignType}
          />
        ) : (
          <ContractInfoEdit
            detailData={detailData}
            setEditable={setEditable}
            saveFlags={saveFlags}
            setSaveFlags={setSaveFlags}
            setData={setData}
            popupState={popupState}
            setPopupState={setPopupState}
            setCommonModals={setCommonModals}
            setEditConfrim={setEditConfrim}
            contractSignType={contractSignType}
            onChangeContractSignType={setContractSignType}
          />
        )
      }
    />
  );
};

export default ContractInfo;
